import styled from "styled-components";
import { TextInputField } from "../../../utils/commonStyledComponents/commonStyled";

export const InheritTextInputField = styled(TextInputField)`
  padding: 10px;
  width: 100%;
  max-width: none;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
`;

export const SubmitButton = styled.div`
  background-color: #ff8038;
  padding: 10px 20px;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 11px;
  cursor: pointer;
  font-weight: bold;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
  &:hover {
    background-color: #e6731b;
  }
  @media (max-width: 649px) {
    height: 50px;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 15px;
  }
`;
